import * as $ from 'jquery'
import {CommandCaller} from "../lib/commands"

export const filterByCategory = async (ajaxPageUrl: string) => {
	const filter = document.getElementById('frontPageCategoryFilterId')
	const target = document.getElementById('frontPageContent')
	if (filter && target) {
		const filterCategoryId = (filter as HTMLFormElement).value
		/* we use jquery here because we need the replacement javascript to be evaluated */
		$(target).replaceWith(await new CommandCaller(ajaxPageUrl).runGet(
			'front page content for category',
			{filterCategoryId: filterCategoryId}
		) as string)
	}
}



// WEBPACK FOOTER //
// ./src/events2/front-page.ts